/*
 * @Author: zwt.daffy
 * @Date: 2019-08-05 09:59:29
 * @Last Modified by: zwt.daffy
 * @Last Modified time: 2019-12-24 17:40:48
 * 企业管理接口
 */
import request from '@/api/base'
// 查询企业列表
const queryCompanyList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/companyBook/queryCompanyBookList', params)
}
// 获取企业详情
const getCompanyInfo = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/companyBook/queryCompanyBookInfo', params)
}
// 新增企业
const addCompany = (params) => {
  return request.post('/portal/companyBook/addCompanyBook', params)
}
const updateCompany = (params) => {
  return request.post('/portal/companyBook/updateCompanyBook', params)
}
const deleteCompany = (params) => {
  return request.post('/portal/companyBook/deleteCompanyBook', params)
}
const queryCompanyAddressBookList = (params) => {
  return request.post('/portal/companyBook/queryCompanyAddressBookList', params)
}

const queryAllCompanyList = (params) => {
  return request.post('/portal/company/queryCompanyList', params)
}
// 获取股东信息列表
const queryCompanyShareHolder = (params) => {
  return request.post('/portal/companyBook/queryCompanyShareHolder', params)
}
// 新增股东信息
const addCompanyShareHolder = (params) => {
  return request.post('/portal/companyBook/addCompanyShareHolder', params)
}
// 删除股东信息
const deleteCompanyShareHolder = (params) => {
  return request.post('/portal/companyBook/deleteCompanyShareHolder', params)
}
// 修改股东信息
const updateCompanyShareHolder = (params) => {
  return request.post('/portal/companyBook/updateCompanyShareHolder', params)
}

// 查询沟通记录
const queryCompanyCommunicationRecord = (params) => {
  return request.post('/portal/companyBook/queryCompanyCommunicationRecord', params)
}
// 新增沟通记录
const addCompanyCommunicationRecord = (params) => {
  return request.post('/portal/companyBook/addCompanyCommunicationRecord', params)
}
// 删除沟通记录
const deleteCompanyCommunicationRecord = (params) => {
  return request.post('/portal/companyBook/deleteCompanyCommunicationRecord', params)
}
// 修改沟通记录
const updateCompanyCommunicationRecord = (params) => {
  return request.post('/portal/companyBook/updateCompanyCommunicationRecord', params)
}

// 对接人信息
// 查询对接人记录
const queryCompanyContactInfo = (params) => {
  return request.post('/portal/companyBook/queryCompanyContactInfo', params)
}
// 新增对接人
const addCompanyContactInfo = (params) => {
  return request.post('/portal/companyBook/addCompanyContactInfo', params)
}
// 删除对接人
const deleteCompanyContactInfo = (params) => {
  return request.post('/portal/companyBook/deleteCompanyContactInfo', params)
}
// 修改对接人信息
const updateCompanyContactInfo = (params) => {
  return request.post('/portal/companyBook/updateCompanyContactInfo', params)
}
// 意向房源
// 查询意向房源
const queryCompanyAddressRelation = (params) => {
  return request.post('/portal/companyBook/queryCompanyAddressRelation', params)
}
// 新增意向房源
const addCompanyAddressRelation = (params) => {
  return request.post('/portal/companyBook/addCompanyAddressRelation', params)
}
// 删除意向房源
const deleteCompanyAddressRelation = (params) => {
  return request.post('/portal/companyBook/deleteCompanyAddressRelation', params)
}
// 修改意向房源
const updateCompanyAddressRelation = (params) => {
  return request.post('/portal/companyBook/updateCompanyAddressRelation', params)
}
// 企业运营信息
// 查询运营信息
const queryCompanyOperation = (params) => {
  return request.post('/portal/companyBook/queryCompanyOperation', params)
}
// 新增企业运营信息
const addCompanyOperation = (params) => {
  return request.post('/portal/companyBook/addCompanyOperation', params)
}
// 删除运营信息
const deleteCompanyOperation = (params) => {
  return request.post('/portal/companyBook/deleteCompanyOperation', params)
}
// 修改运营信息
const updateCompanyOperation = (params) => {
  return request.post('/portal/companyBook/updateCompanyOperation', params)
}
// 企业运营信息政府支持
// 查询运营信息
const queryCompanyOperationSupport = (params) => {
  return request.post('/portal/companyBook/queryCompanyOperationSupport', params)
}
// 新增企业运营信息
const addCompanyOperationSupport = (params) => {
  return request.post('/portal/companyBook/addCompanyOperationSupport', params)
}
// 删除运营信息
const deleteCompanyOperationSupport = (params) => {
  return request.post('/portal/companyBook/deleteCompanyOperationSupport', params)
}
// 修改运营信息
const updateCompanyOperationSupport = (params) => {
  return request.post('/portal/companyBook/updateCompanyOperationSupport', params)
}
// 人员信息-基本信息
// 获取
const queryCompanyStaffAdditionalInfo = (params) => {
  return request.post('/portal/companyBook/queryCompanyStaffAdditionalInfo', params)
}
// 修改
const addAndUpdateCompanyStaffAdditionalInfo = (params) => {
  return request.post('/portal/companyBook/addAndUpdateCompanyStaffAdditionalInfo', params)
}
// 人员信息-人才统计
// 查询人员
const queryCompanyStaffQualifiedStatistic = (params) => {
  return request.post('/portal/companyBook/queryCompanyStaffQualifiedStatistic', params)
}
// 新增人员信息
const addCompanyStaffQualifiedStatistic = (params) => {
  return request.post('/portal/companyBook/addCompanyStaffQualifiedStatistic', params)
}
// 删除人员信息
const deleteCompanyStaffQualifiedStatistic = (params) => {
  return request.post('/portal/companyBook/deleteCompanyStaffQualifiedStatistic', params)
}
// 修改人员信息
const updateCompanyStaffQualifiedStatistic = (params) => {
  return request.post('/portal/companyBook/updateCompanyStaffQualifiedStatistic', params)
}
// 人员信息-人员统计
// 查询人员
const queryCompanyStaffStatistic = (params) => {
  return request.post('/portal/companyBook/queryCompanyStaffStatistic', params)
}
// 新增人员信息
const addCompanyStaffStatistic = (params) => {
  return request.post('/portal/companyBook/addCompanyStaffStatistic', params)
}
// 删除人员信息
const deleteCompanyStaffStatistic = (params) => {
  return request.post('/portal/companyBook/deleteCompanyStaffStatistic', params)
}
// 修改人员信息
const updateCompanyStaffStatistic = (params) => {
  return request.post('/portal/companyBook/updateCompanyStaffStatistic', params)
}
// 融资情况
// 查询融资
const queryCompanyCapitalization = (params) => {
  return request.post('/portal/companyBook/queryCompanyCapitalization', params)
}
// 新增融资
const addCompanyCapitalization = (params) => {
  return request.post('/portal/companyBook/addCompanyCapitalization', params)
}
// 删除融资
const deleteCompanyCapitalization = (params) => {
  return request.post('/portal/companyBook/deleteCompanyCapitalization', params)
}
// 修改融资
const updateCompanyCapitalization = (params) => {
  return request.post('/portal/companyBook/updateCompanyCapitalization', params)
}
// 获奖情况及其他需说明情况
// 查询获奖
const queryCompanyAwards = (params) => {
  return request.post('/portal/companyBook/queryCompanyAwards', params)
}
// 新增获奖
const addCompanyAwards = (params) => {
  return request.post('/portal/companyBook/addCompanyAwards', params)
}
// 删除获奖
const deleteCompanyAwards = (params) => {
  return request.post('/portal/companyBook/deleteCompanyAwards', params)
}
// 修改获奖
const updateCompanyAwards = (params) => {
  return request.post('/portal/companyBook/updateCompanyAwards', params)
}
// 查询账单接收人
const queryBillRecipients = (params) => {
  return request.post('/portal/companyBook/queryBillRecipients', params)
}
// 新增账单接收人
const addBillRecipient = (params) => {
  return request.post('/portal/companyBook/addBillRecipient', params)
}
// 修改账单接收人
const updateBillRecipient = (params) => {
  return request.post('/portal/companyBook/updateBillRecipient', params)
}
// 删除账单接收人
const deleteBillRecipient = (params) => {
  return request.post('/portal/companyBook/deleteBillRecipient', params)
}
// 导出企业列表
const exportCompanyInfo = (params) => {
  return request.post('/portal/company/exportCompanyInfo', params, {responseType: 'blob'})
}

// 输入企业名称查询相似企业
const getResembleCompany = (params) => {
  return request.post('/portal/company/queryListByLucene', params)
}
const getOrgAttriList = (params) => {
  return request.post('/portal/companyOrgAttri/queryCompanyOrgAttriList', params)
}

const getKeepperList = (params) => {
  return request.post('/portal/commercialProjectPeople/butlerList', params)
}
const setKeepperList = (params) => {
  return request.post('/portal/commercialProjectPeople/saveButlerList', params)
}
// 企业提前入驻
const getCompanyEnterApplyList = (params) => {
  return request.post('/portal/company/queryCompanyEnterApplyList', params)
}
// 添加提前入驻申请
const addCompanyEnterApply = (params) => {
  return request.post('/portal/company/addCompanyEnterApply', params)
}
// 修改删除企业入驻申请
const updateCompanyEnterApply = (params) => {
  return request.post('/portal/company/updateCompanyEnterApply', params)
}
// 查询入驻地址详情
const queryCompanyEnterApplyDetail = (params) => {
  return request.get('/portal/company/queryCompanyEnterApplyDetail', {params})
}
// 查询用户列表
const queryUserList = (params) => {
  return request.post('/portal/user/findCompanyStaffs', params)
}
// 获取企业详情
const getCompanyInfos = (params) => {
  return request.get('/portal/company/getCompanyInfo', {params})
}
// 查询用户详情
const findUserCompanyTaffById = (params) => {
  // params.mockApi = true
  return request.get('/portal/user/findUserCompanyTaffById', {params})
}
// 添加或者修改用户
const addandUpdateCompanyStaff = (params) => {
  // params.mockApi = true
  return request.post('/portal/user/addandUpdateCompanyStaff', params)
}

// 查询企业的发票
const queryByCompanyId = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.get('/portal/companyInvoice/queryByCompanyId', { params })
}
// 修改企业的发票
const updateInvoiceInfo = (params) => {
  // params.mockApi = true
  return request.post('/portal/companyInvoice/updateInvoiceInfo', params)
}
// 新增加 企业的发票
const addInvoiceInfo = (params) => {
  // params.mockApi = true
  return request.post('/portal/companyInvoice/addInvoiceInfo', params)
}
// 删除 企业的发票
const deleteInvoiceInfo = (params) => {
  // params.mockApi = true
  return request.post('/portal/companyInvoice/deleteInvoiceInfo', params)
}
// 重复校验 企业的发票
const companyInvoiceIsExist = (params) => {
  // params.mockApi = true
  return request.post('/portal/companyInvoice/isExist', params)
}
// 检查手机号是否存在
const findUserIsExit = (params) => {
  // params.mockApi = true
  return request.get('/portal/user/findUserIsExit', {params})
}
// 其他企业禁用启用
const updateOtherCompany = (params) => {
  return request.post('/portal/company/updateCompany', params)
}
// 其他企业菜单配置
const getAllMenu = (params) => {
  return request.get('/portal/menu/getMenuTreeByParkIdAndType', {params})
}
const getCompanyMenu = (params) => {
  return request.post('/portal/companyMenus/getCompanyMenus', params)
}
const getOrgAttriMenu = (params) => {
  return request.post('/portal/companyMenus/getMenusConfigByOrgAttri', params)
}
const setOrgAttriMenu = (params) => {
  return request.post('/portal/companyMenus/setMenusConfig', params)
}
const setCompanyMenu = (params) => {
  return request.post('/portal/companyMenus/setCompanyMenus', params)
}
// 其他企业入驻新增
const addCompanyOther = (params) => {
  return request.post('/portal/company/add', params)
}
// 设置企业超级管理员
const setCompanySuperAdmin = (params) => {
  return request.post('/portal/user/setCompanySuperAdmin', params)
}
const getActivitiesInfo = (params) => {
  return request.post('/ipark-admin/activities/getActivitiesInfo', params)
}
const getTopicInfo = (params) => {
  return request.post('/ipark-admin/topic/getTopicInfo', params)
}

const getApplicationById = (params) => {
  return request.post('/ipark-admin/activities/getActivitiesInfo', params)
}
const loadCustomizeServiceAsTree = (params) => {
  return request.post('/ipark-admin/service/loadCustomizeServiceAsTree', params)
}
const getPortalById = (params) => {
  return request.post('/ipark-admin/appconfig/getPortalById', params)
}

const appconfigGetApplicationById = (params) => {
  return request.post('/ipark-admin/appconfig/getApplicationById', params)
}

// 批量新增修改删除项目信息里面的落地企业
const batchAddCommercialFloor = (params) => {
  return request.post('/portal/companyBook/batchAddCommercialFloor', params)
}
const batchUpdateCommercialFloor = (params) => {
  return request.post('/portal/companyBook/batchUpdateCommercialFloor', params)
}
// 验证落地企业名称是否重复
const checkCompanyName = (params) => {
  return request.post('/portal/company/checkCompanyName', params)
}
// 修改企业
const updateCompanyOther = (params) => {
  return request.post('/portal/company/updateCompany', params)
}

// 导出企业台账
const exportCompanyAccount = (params) => {
  return request.post('/portal/companyBook/queryCompanyAddressBookList/export', params, {responseType: 'blob'})
}

export default {
  queryByCompanyId,
  updateInvoiceInfo,
  companyInvoiceIsExist,
  addInvoiceInfo,
  deleteInvoiceInfo,
  queryCompanyList,
  addCompany,
  exportCompanyInfo,
  getCompanyInfo,
  updateCompany,
  deleteCompany,
  queryAllCompanyList,
  queryCompanyAddressBookList,
  queryCompanyShareHolder,
  addCompanyShareHolder,
  deleteCompanyShareHolder,
  updateCompanyShareHolder,
  queryCompanyCommunicationRecord,
  addCompanyCommunicationRecord,
  deleteCompanyCommunicationRecord,
  updateCompanyCommunicationRecord,
  queryCompanyContactInfo,
  addCompanyContactInfo,
  deleteCompanyContactInfo,
  updateCompanyContactInfo,
  queryCompanyAddressRelation,
  addCompanyAddressRelation,
  deleteCompanyAddressRelation,
  updateCompanyAddressRelation,
  queryCompanyOperation,
  addCompanyOperation,
  deleteCompanyOperation,
  updateCompanyOperation,
  queryCompanyOperationSupport,
  addCompanyOperationSupport,
  deleteCompanyOperationSupport,
  updateCompanyOperationSupport,
  queryCompanyStaffAdditionalInfo,
  addAndUpdateCompanyStaffAdditionalInfo,
  queryCompanyStaffQualifiedStatistic,
  addCompanyStaffQualifiedStatistic,
  deleteCompanyStaffQualifiedStatistic,
  updateCompanyStaffQualifiedStatistic,
  queryCompanyStaffStatistic,
  addCompanyStaffStatistic,
  deleteCompanyStaffStatistic,
  updateCompanyStaffStatistic,
  queryCompanyCapitalization,
  addCompanyCapitalization,
  deleteCompanyCapitalization,
  updateCompanyCapitalization,
  queryCompanyAwards,
  addCompanyAwards,
  deleteCompanyAwards,
  updateCompanyAwards,
  getResembleCompany,
  getKeepperList,
  setKeepperList,
  getCompanyEnterApplyList,
  addCompanyEnterApply,
  updateCompanyEnterApply,
  getOrgAttriList,
  queryUserList,
  getCompanyInfos,
  findUserCompanyTaffById,
  addandUpdateCompanyStaff,
  findUserIsExit,
  updateOtherCompany,
  getAllMenu,
  getCompanyMenu,
  getOrgAttriMenu,
  setOrgAttriMenu,
  setCompanyMenu,
  setCompanySuperAdmin,
  addCompanyOther,
  getActivitiesInfo,
  appconfigGetApplicationById,
  getPortalById,
  getApplicationById,
  getTopicInfo,
  loadCustomizeServiceAsTree,
  batchAddCommercialFloor,
  batchUpdateCommercialFloor,
  checkCompanyName,
  updateCompanyOther,
  exportCompanyAccount,
  queryCompanyEnterApplyDetail,
  queryBillRecipients,
  addBillRecipient,
  updateBillRecipient,
  deleteBillRecipient
}



// WEBPACK FOOTER //
// ./src/area-contract/api/companyService.js